var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayCircleNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 40.3334C12.3745 40.3334 4.16666 32.1255 4.16666 22C4.16666 11.8745 12.3745 3.66669 22.5 3.66669C32.6255 3.66669 40.8333 11.8745 40.8333 22C40.8333 32.1255 32.6255 40.3334 22.5 40.3334ZM19.9737 15.4275C19.8633 15.3539 19.7351 15.3116 19.6026 15.3051C19.4701 15.2986 19.3384 15.3281 19.2213 15.3906C19.1043 15.4531 19.0064 15.5461 18.9381 15.6598C18.8698 15.7735 18.8336 15.9035 18.8333 16.0362V27.9639C18.8336 28.0965 18.8698 28.2266 18.9381 28.3403C19.0064 28.454 19.1043 28.547 19.2213 28.6094C19.3384 28.6719 19.4701 28.7015 19.6026 28.6949C19.7351 28.6884 19.8633 28.6461 19.9737 28.5725L28.9185 22.6105C29.0191 22.5436 29.1016 22.4528 29.1586 22.3463C29.2157 22.2398 29.2455 22.1208 29.2455 22C29.2455 21.8792 29.2157 21.7602 29.1586 21.6537C29.1016 21.5472 29.0191 21.4565 28.9185 21.3895L19.9718 15.4275H19.9737Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleNew);
export default __webpack_public_path__ + "static/media/play-circle-new.0c3c9ed0.svg";
export { ForwardRef as ReactComponent };